import React, { useEffect, useContext, useState } from 'react';
import './application-submitted.scss';
import { VodalendPersonalLogo, OmfLogo, TickOutline } from 'assets';
import { LendingContext } from 'context';
import { TealiumService } from 'services';
import { applicationDefaults } from 'utils';

const DEEPLINK = 'DEEPLINK';

export const ApplicationSubmitted = () => {
  const { application } = useContext(LendingContext);
  const [crossSellBanner, setCrossSellBanner] = useState(null);

  useEffect(() => {
    const omfOffer = JSON.parse(sessionStorage.getItem('omfOffer') || 'null');
    TealiumService.onApplicationSubmittedStart(omfOffer, application?.offers?.hashId);

    const stored = JSON.parse(sessionStorage.getItem('crossSellBanner') || 'null');
    if (stored) {
      setCrossSellBanner({
        imageUrl: stored.imageUrl,
        deepLink: stored.deepLink,
        analyticsTag: stored.analyticsTag,
        buttonText: stored.buttonText,
      });
    }
  }, []);

  return (
    <section className='app-submitted'>
      <header className='documents-header'>
        <h1 className='documents-header__title'>Confirmation</h1>
      </header>
      <main className='app-submitted__content'>
        <div className='app-submitted__body'>
          <div className='app-submitted__check-wrap' aria-hidden='true'>
            <img className='app-submitted__checkmark' src={TickOutline} alt='' />
          </div>

          <h2 className='app-submitted__heading'>Application submitted successfully</h2>

          <p className='app-submitted__description'>
            Please expect a call from our trusted partner, Old Mutual Finance. They will contact you
            shortly from 021 980 0655.
          </p>

          { crossSellBanner ? (
            <figure
              className='cross-sell-banner v-container'
              style={{ backgroundImage: `url(${crossSellBanner.imageUrl})` }}
              onClick={() => {
                window.utag?.link({ link_id: crossSellBanner.analyticsTag });
                window.my?.postMessage({ messageType: DEEPLINK, breakoutUrl: crossSellBanner.deepLink }, '*');
              }}
            >
              {crossSellBanner.buttonText && <button className='cross-sell-banner-button'>{crossSellBanner.buttonText}</button>}
            </figure>
          ) : null}
        </div>

        <footer className='app-submitted__footer'>
          <img
            className='app-submitted__vodalend-logo'
            src={VodalendPersonalLogo}
            alt='VodaLend personal loans'
          />

          <div className='app-submitted__branding'>
            <img
              className='app-submitted__omf-logo'
              src={OmfLogo}
              alt='Old Mutual Finance'
            />
          </div>

          <button
            className='app-submitted__finish'
            onClick={() => (window.location.href = applicationDefaults.staticHomeUrl)}
          >
            Finish
          </button>
        </footer>
      </main>
    </section>
  );
};
